import { HTMLAttributes } from 'react';

import styled from '@emotion/styled';

import gradeStyle from '../../../../constant/gradeStyle';

import { Grade } from '../../enums';

const Span = styled.span<{ grade: Grade; }>`
  display: inline-block;
  min-width: 38px;
  height: 16px;
  margin-right: 4px;
  padding: 0 4px;
  border-radius: 30px;
  font-size: 10px;
  color: #fff;
  line-height: 14px;
  text-align: center;
  letter-spacing: -0.3px;
  vertical-align: 0;
  ${({ grade }) => gradeStyle[grade]}
`;

interface Props extends HTMLAttributes<HTMLSpanElement> {
  grade: Grade;
}

export default function GradeIcon({
  grade,
  ...props
}: Props) {
  return (
    <Span grade={grade} {...props}>{grade}</Span>
  );
}
